import {
  ArrowRight,
  Home,
  LogIn,
  LogOut,
  MapPin,
  Menu,
  X
} from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const AdvancedRoofBidderHeader = ({ children }) => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user, signOut } = useAuth();

  const handleGetQuote = () => navigate("/get-quote");
  const handleCompareBids = () => navigate("/compare-bid");
  const handleOrders = () => navigate("/orders");
  const handleHome = () => navigate("/");
  const handleInstallers = () => navigate("/installer");

  return (
    <div className="min-h-screen">
      <header className="bg-white/95 backdrop-blur-md shadow-sm border-b border-gray-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div
              className="flex items-center cursor-pointer"
              onClick={handleHome}
            >
              <div className="bg-gradient-to-r from-blue-600 to-indigo-600 p-3 rounded-xl shadow-lg">
                <Home className="w-7 h-7 text-white" />
              </div>
              <div className="ml-4">
                <div className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
                  RoofBidder
                </div>
                <div className="text-xs text-gray-500 font-medium">
                  your roof, your budget, your power
                </div>
              </div>
            </div>

            <nav className="hidden lg:flex items-center space-x-12">
              <button
                onClick={handleHome}
                className="text-gray-700 hover:text-blue-600 font-semibold transition-all duration-300 hover:scale-105"
              >
                Home
              </button>
              <button
                onClick={handleCompareBids}
                className="text-gray-700 hover:text-blue-600 font-semibold transition-all duration-300 hover:scale-105"
              >
                Compare Bids
              </button>
              <button
                onClick={handleOrders}
                className="text-gray-700 hover:text-blue-600 font-semibold transition-all duration-300 hover:scale-105"
              >
                Orders
              </button>
              {/* <button
                data-testid="for-installers-link"
                onClick={handleInstallers}
                className="text-gray-700 hover:text-blue-600 font-semibold transition-all duration-300 hover:scale-105 flex items-center gap-2"
              >
                <HardHat className="w-4 h-4" />
                For Installers
              </button> */}
            </nav>

            <div className="hidden lg:flex items-center space-x-4">
              {!user ? (
                <button
                  data-testid="header-sign-in-button"
                  onClick={() => navigate("/login")}
                  className="px-4 py-2 rounded-xl font-medium text-gray-700 hover:text-blue-600 transition-colors flex items-center gap-2"
                >
                  <LogIn className="w-4 h-4" /> Sign In
                </button>
              ) : (
                <>
                  {/* <div
                    className="text-sm text-gray-600"
                    data-testid="header-user-email"
                  >
                    {user.email}
                  </div> */}
                  <button
                    data-testid="header-sign-out-button"
                    onClick={async () => {
                      await signOut();
                    }}
                    className="px-4 py-2 rounded-xl font-medium text-gray-700 hover:text-red-600 transition-colors flex items-center gap-2"
                  >
                    <LogOut className="w-4 h-4" /> Sign Out
                  </button>
                </>
              )}
              <button
                onClick={handleGetQuote}
                className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-8 py-3 rounded-xl font-semibold hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 flex items-center space-x-2 shadow-lg hover:shadow-xl transform hover:scale-105"
              >
                <MapPin className="w-5 h-5" />
                <span>Get Free Quote</span>
                <ArrowRight className="w-5 h-5" />
              </button>
            </div>

            <div className="lg:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-gray-700 hover:text-blue-600 transition-colors p-2"
              >
                {isMenuOpen ? (
                  <X className="w-7 h-7" />
                ) : (
                  <Menu className="w-7 h-7" />
                )}
              </button>
            </div>
          </div>

          {isMenuOpen && (
            <div className="lg:hidden py-6 border-t border-gray-200 bg-white/95 backdrop-blur-md">
              <div className="space-y-6">
                <button
                  onClick={handleHome}
                  className="block w-full text-left text-gray-700 hover:text-blue-600 font-semibold py-3 text-lg"
                >
                  Home
                </button>
                <button
                  onClick={handleCompareBids}
                  className="block w-full text-left text-gray-700 hover:text-blue-600 font-semibold py-3 text-lg"
                >
                  Compare Bids
                </button>
                <button
                  onClick={handleOrders}
                  className="block w-full text-left text-gray-700 hover:text-blue-600 font-semibold py-3 text-lg"
                >
                  Orders
                </button>
                {/* <button
                  data-testid="mobile-for-installers-link"
                  onClick={handleInstallers}
                  className="block w-full text-left text-gray-700 hover:text-blue-600 font-semibold py-3 text-lg"
                >
                  For Installers
                </button> */}
                {!user ? (
                  <button
                    data-testid="mobile-sign-in-button"
                    onClick={() => navigate("/login")}
                    className="block w-full text-left text-gray-700 hover:text-blue-600 font-semibold py-3 text-lg"
                  >
                    Sign In
                  </button>
                ) : (
                  <button
                    data-testid="mobile-sign-out-button"
                    onClick={async () => {
                      await signOut();
                    }}
                    className="block w-full text-left text-gray-700 hover:text-red-600 font-semibold py-3 text-lg"
                  >
                    Sign Out
                  </button>
                )}
                <div className="pt-4 space-y-3">
                  <button
                    onClick={handleCompareBids}
                    className="w-full px-6 py-3 text-blue-600 bg-blue-50 hover:bg-blue-100 rounded-xl font-semibold transition-all duration-300"
                  >
                    View Bids
                  </button>
                  <button
                    onClick={handleGetQuote}
                    className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-8 py-4 rounded-xl font-semibold hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 flex items-center justify-center space-x-2 shadow-lg"
                  >
                    <MapPin className="w-5 h-5" />
                    <span>Get Free Quote</span>
                    <ArrowRight className="w-5 h-5" />
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </header>

      <main>{children}</main>
    </div>
  );
};

export default AdvancedRoofBidderHeader;
